export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCES';
export const FETCH_PRODUCTS_ERROR = 'FETCH_PRODUCTS_ERROR';

//users
export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGIN_LOGOUT = "USER_LOGIN_LOGOUT";
export const USER_RESET_PASSWORD ="USER_RESET_PASSWORD";

//FetchUsers
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR';

//reviews
export const FETCH_REVIEWS_REQUEST = 'FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'FETCH_REVIEWS_SUCCES';
export const FETCH_REVIEWS_ERROR = 'FETCH_REVIEWS_ERROR';

//cart
export const FETCH_ITEMS_REQUEST = 'FETCH_ITEMS_REQUEST';
export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_ITEMS_GET = 'CART_ITEMS_GET';
export const CART_REMOVE_ITEMS = 'CART_REMOVE_ITEMS';
export const FETCH_ITEM_ERROR = 'FETCH_ITEM_ERROR';
export const JOIN_CARTS = 'JOIN_CARTS';
export const UPDATE_ITEM_CART = 'UPDATE_ITEM_CART'

//cartGuest
export const FETCH_ITEMS_GUEST_REQUEST = 'FETCH_ITEMS_GUEST_REQUEST';
export const CART_ADD_ITEM_GUEST = 'CART_ADD_ITEM_GUEST';
export const CART_REMOVE_ITEM_GUEST = 'CART_REMOVE_ITEM_GUEST';
export const CART_ITEMS_GET_GUEST = 'CART_ITEMS_GET_GUEST';
export const CART_REMOVE_ITEMS_GUEST = 'CART_REMOVE_ITEMS_GUEST';
export const FETCH_ITEM_ERROR_GUEST = 'FETCH_ITEM_ERROR_GUEST';

//order
export const FETCH_ORDER_CHECK_REQUEST = 'FETCH_ORDER_CHECK_REQUEST';
export const FETCH_ORDER_CHECK_SUCCESS = 'FETCH_ORDER_CHECK_SUCCESS';
export const FETCH_ORDER_ERROR = 'FETCH_ORDER_ERROR';
export const GET_ORDERS_USER = 'GET_ORDERS_USER';


//orders
export const GET_ALL_ORDERS = 'GET_ALL_ORDERS';
export const CREATE_ORDER = 'CREATE_ORDER';
export const DELETE_ORDER = 'DELETE_ORDER';
export const UPDATE_ORDER = 'UPDATE_ORDER';

//email
export const SEND_EMAIL = 'SEND_EMAIL'
export const ERROR_SEND_EMAIL = 'ERROR_SEND_EMAIL'
export const REQUEST_SEND_EMAIL = 'REQUEST_SEND_EMAIL'
